module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-box container-box"
  }, [_c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    staticClass: "box-item icon-box"
  }, [_c('ni-icon', {
    style: ({
      paddingRight: '5px'
    }),
    attrs: {
      "icon": _vm.icon,
      "iconStyle": {
        width: '2.5em',
        height: '2.5em',
        top: '1px',
        left: '2px'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "header_title"
  }, [_vm._v("\n          " + _vm._s(_vm.headerTitle) + "\n        ")]), _vm._v(" "), _vm._t("left-tool")], 2)]), _vm._v(" "), (_vm.showRight) ? _c('div', {
    staticClass: "flex-box right-btn-box"
  }, [_c('span', {
    staticClass: "super-search-content"
  }, [_vm._t("right-tool"), _vm._v(" "), (_vm.showSupper) ? _c('el-popover', {
    attrs: {
      "popper-class": "super-search",
      "placement": "bottom",
      "width": _vm.superSearchWidth,
      "trigger": "click"
    },
    on: {
      "show": function($event) {
        return _vm.show_back(true)
      },
      "hide": function($event) {
        return _vm.show_back(false)
      }
    }
  }, [_c('el-row', {
    staticClass: "content"
  }, [_c('el-row', {
    staticStyle: {
      "display": "flex",
      "padding-top": "12px"
    }
  }, [_c('ni-icon', {
    attrs: {
      "icon": "#cms_gaojisousuo-"
    }
  }), _vm._v(" "), _c('span', [_vm._v("高级搜索")])], 1), _vm._v(" "), _c('ni-line'), _vm._v(" "), _c('el-row', {
    staticClass: "super-content"
  }, [_vm._t("super-content")], 2), _vm._v(" "), (_vm.$slots.super_bottom) ? _c('el-row', {
    staticClass: "super-bottom"
  }, [_vm._t("super_bottom")], 2) : _vm._e()], 1), _vm._v(" "), _c('ni-button', {
    attrs: {
      "slot": "reference",
      "icon": "#cms_gaojisousuo-"
    },
    slot: "reference"
  }, [_vm._v("\n              高级\n            ")])], 1) : _vm._e()], 2), _vm._v(" "), (_vm.showMore) ? _c('el-popover', {
    attrs: {
      "popper-class": "more-op-popper",
      "placement": "bottom",
      "width": "130",
      "trigger": "click"
    }
  }, [_vm._t("right-more"), _vm._v(" "), _c('ni-button', {
    staticClass: "more",
    attrs: {
      "slot": "reference",
      "icon": "el-icon-more"
    },
    slot: "reference"
  })], 2) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-65f9d7d7","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/form-header/form-header.vue
// module id = meG8
// module chunks = 81